import { render, staticRenderFns } from "./NavigationLinks.vue?vue&type=template&id=189c79f2&scoped=true&"
import script from "./NavigationLinks.vue?vue&type=script&lang=js&"
export * from "./NavigationLinks.vue?vue&type=script&lang=js&"
import style0 from "./NavigationLinks.vue?vue&type=style&index=0&id=189c79f2&prod&lang=scss&scoped=true&"
import style1 from "./NavigationLinks.vue?vue&type=style&index=1&id=189c79f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c79f2",
  null
  
)

export default component.exports